import { pageLoad } from './utils/analytics.js';
import Vue from 'vue';
import 'core-js/stable';
import { extend, localize, ValidationObserver, ValidationProvider } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import Multiselect from 'vue-multiselect';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BootstrapVueIcons } from 'bootstrap-vue';
import languageBundle from '@kirschbaum-development/laravel-translations-loader/php!@kirschbaum-development/laravel-translations-loader';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import { routes } from './routes';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import store from './store';
import VueMeta from 'vue-meta';
import VueExcelXlsx from 'vue-excel-xlsx';

window._ = require('lodash');
window.axios = require('axios');

require('./bootstrap');

Vue.use(VueMeta);

Vue.component('multiselect', Multiselect);

Vue.use(require('bootstrap-vue'));

Vue.use(BootstrapVueIcons);

Vue.use(VueI18n);

Vue.use(VueRouter);

Vue.use(VueExcelXlsx);

Vue.component('font-awesome-icon', FontAwesomeIcon);

// Common Utilities
Vue.component('loading', require('./components/utility/Loading.vue').default);
Vue.component('loading-spinner', require('./components/common/LoadingSpinner.vue').default);
Vue.component('promise', require('./components/utility/Promise.vue').default);
Vue.component('field-error', require('./components/utility/FieldError.vue').default);

Vue.component('set-timezone', require('./components/utility/SetTimezone.vue').default);
Vue.component('thank-you', require('./components/common/ThankYou.vue').default);
Vue.component('terms-of-use', require('./components/support/TermsOfUse.vue').default);
Vue.component(
  'application-support-numbers',
  require('./components/support/ApplicationSupport/ApplicationSupportNumbers.vue').default,
);
Vue.component(
  'safety-contacts',
  require('./components/support/ApplicationSupport/SafetyContacts.vue').default,
);

// Install VeeValidate components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
localize({
  en: {
    messages: {
      required: '*This field is required',
      email: '*This email address is invalid. Please try again',
      min: '*This field must have no less than {length} characters',
      max: (_, { length }) => `*This field must have no more than ${length} characters`,
      isValidPercentage: '*The summary of the above answers must be equal to 100%',
      confirmed: 'The email confirmation does not match',
      regex: 'The form is invalid',
    },
  },
});

Vue.component('help-button', require('./components/support/HelpButton.vue').default);
Vue.component('dashboard', require('./components/Dashboard.vue').default);
Vue.component('welcome-button', require('./components/WelcomeButton.vue').default);

// Manage Users (Admin)
Vue.component('manage-users-root', require('./components/admin/users/ManageUsers.vue').default);
Vue.component('groups', require('./components/admin/users/Groups.vue').default);

// CSSET-MS (Eric's Project)
Vue.component('csset-studies', require('./components/csset-ms/StudiesTable.vue').default);
Vue.component('passport-clients', require('./components/csset-ms/PassportClients.vue').default);

// Salesforce Users (Admin)
Vue.component(
  'salesforce-admin-panel',
  require('./components/admin/salesforce/AdminPanel.vue').default,
);

Vue.component('document-security', require('./components/utility/DocumentSecurity.vue').default);
Vue.component('external-login', require('./components/utility/ExternalLogin.vue').default);

Vue.prototype.$appName = 'Simplify - ';

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // navigate to saved position or to top of page
    return savedPosition || { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (!to.meta || !to.meta.permission) {
    next();
    return;
  }

  axios
    .get('/api/user/permissions')
    .then(response => {
      const permissions = response.data.permissions;
      if (!permissions.includes(to.meta.permission)) {
        next({ name: 'site-summary', params: to.params });
      } else {
        next();
      }
    })
    .catch(error => {
      console.log(error);
      next({ name: 'not-allowed' });
    });
});

router.afterEach(to => {
  pageLoad(to.path);
});

const app = new Vue({
  i18n: new VueI18n({ locale: window.locale, messages: languageBundle }),
  el: '#app',
  store,
  router: router,
});
